module.exports = __webpack_public_path__ + "static/media/frames-1.dea19e72.jpg";